import { createSlice } from '@reduxjs/toolkit';

import { Passenger } from './Passenger';

export interface IPassengerState {
  passengers: Passenger[];
  passengerSearchTerm: string;
  passengerMergeModalOpen: boolean;
}

export const initialState: IPassengerState = {
  passengers: [],
  passengerSearchTerm: '',
  passengerMergeModalOpen: false,
};

export const passengerSlice = createSlice({
  name: 'passenger',
  initialState,
  reducers: {
    setPassengers: (state, action: { payload: Passenger[]; type: string }) => {
      state.passengers = action.payload;
    },
    setPassengerSearchTerm: (
      state,
      action: { payload: string; type: string }
    ) => {
      state.passengerSearchTerm = action.payload;
    },
    setPassengerMergeModalOpen: (state, action: { payload: boolean }) => {
      state.passengerMergeModalOpen = action.payload;
    },
  },
});

export const {
  setPassengers,
  setPassengerSearchTerm,
  setPassengerMergeModalOpen,
} = passengerSlice.actions;
